/*
 * The Job round: turning the pain the room voted for into the sentence the deck
 * gets held against. From the prototype's frame screens.
 *
 * Two shapes, chosen by `config.userStoryEnabled`: the three-part user story, or
 * one plain sentence. The story is the default because naming a role is the part
 * rooms skip, and the field labels are what force it.
 */

export const JOB_COPY = {
  heading: "Name the job.",
  result: "Result",
  objective: "Turn the pain you chose into the job you want done.",
  fromPains: "The pains this job answers",

  /** The user-story form. The labels are the sentence, so they read in order. */
  whoLabel: "As a",
  whoPlaceholder: "dispatcher",
  whatLabel: "I want",
  whatPlaceholder: "early warning of staffing gaps",
  whyLabel: "So that",
  whyPlaceholder: "the first trucks leave on time",

  /** The plain form. */
  plainLabel: "The problem",
  plainPlaceholder: "Dispatch finds out it is short on drivers on Monday morning",

  holdsHint: "The sentence holds. Lock it.",
  incompleteHint: "The deck stays shut until this sentence holds.",
  lockedHint: "Job locked. The deck is open.",
  unwritten: "The job gets written in this round.",
  waiting: "The facilitator is writing the job.",

  /** Editing a locked job from a later round (see `JobEditModal`). */
  editAction: "Edit",
  editTitle: "Edit the job",
  editBlurb: "The room will only see your changes when you click Save.",
  editSave: "Save changes",
  editCancel: "Cancel",
} as const
